module.exports = __webpack_public_path__ + "media/images/icons/icn_028-8828ad979cce101b00351f484cc7afb0.svg";